import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'AMS' },
    { value: 2, label: 'EBS' },
    { value: 3, label: 'Vendor' },
  ],
});
